<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>意见反馈列表</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :inline="true" ref="formInline" :model="formInline" class="demo-form-inline">
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="formInline.phone" placeholder="手机号"></el-input>
            </el-form-item>
    
            <el-form-item>
                <el-button type="primary" @click="Search">查询</el-button>
                <el-button @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
        </el-form>
    
        <el-table :data="fetchList" v-loading="loading" element-loading-text="拼命加载中" :default-sort="{prop: 'status'}">
            <el-table-column prop="id" label="ID">
            </el-table-column>
            <el-table-column prop="userManage.nickName" label="用户昵称">
            </el-table-column>
            <el-table-column prop="phone" label="手机号">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="反馈类型">
                <div>
                    <span v-if="row.type === 0">产品建议</span>
                    <span v-if="row.type === 1">程序错误</span>
                </div>
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="提交时间">
                <span v-if="row.created">{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="状态" sortable prop="status">
                <div>
                    <span v-if="row.status === 0 || row.status === null">未处理</span>
                    <span v-if="row.status === 1">已处理</span>
                </div>
            </el-table-column>
            <el-table-column inline-template :context="_self" width="200" label="操作">
                <span>
                                                                            <el-button @click="handleCheck($index, row)" type="text" size="small" v-if="row.status === 0 || row.status === null">标记已反馈</el-button>
                                                                            <el-button type="text" size="small" v-if="row.status === 1">已反馈</el-button>
                                                                            <el-button @click="handleView($index, row)" type="text" size="small">查看</el-button>
                                                                            <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="Role === '1'">删除</el-button>
                                                                </span>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination>
    
        <el-dialog title="查看反馈详情" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="用户昵称：" label-width="150px">
                    <span v-if="form.userManage">{{form.userManage.nickName}}</span>
                </el-form-item>
                <el-form-item label="反馈类型：" label-width="150px">
                    <span v-if="form.type === 0">产品建议</span>
                    <span v-if="form.type === 1">程序错误</span>
                </el-form-item>
                <el-form-item label="联系方式：" label-width="150px">
                    <span v-if="form.userManage">{{form.userManage.username}}</span>
                </el-form-item>
                <el-form-item label="反馈内容：" label-width="150px">
                    <span v-if="form.content">{{form.content}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    
    </div>
</template>

<script>
    import {
        getComments,
        getUsersDetail,
        getOrderDetail,
        putComments,
        deleteComments,
        filterComments,
        getFeedBack,
        patchFeedBack,
        deleteFeedBack,
        filterFeedBack,
        getFeedCount,
        filterUser
    } from '../../api/version'
    
    
    export default {
        data() {
            return {
                Role: sessionStorage.power,
                loading: true,
                totalNum: 0,
                currentPage: 1,
                fetchList: [],
                formInline: {
                    phone: ''
                },
                dialogFormVisible: false,
                userInfo: '',
                form: {
                    orderId: '',
    
                },
                filter: {}
    
            }
        },
    
        created() {
            this.filter = JSON.stringify({
                'include': 'userManage',
                "order": "id desc",
                "limit": 20,
                "skip": 0,
            })
            //获取所有评论列表
            getFeedBack(sessionStorage.userId, this.filter).then(res => {
                this.fetchList = res.data
                this.loading = false
                console.log(this.fetchList)
    
            })
    
            getFeedCount(sessionStorage.userId, JSON.stringify({})).then(res => {
                console.log(res.data)
                this.totalNum = res.data.count
            })
    
        },
    
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.loading = true
                let filter = JSON.parse(this.filter)
                filter.skip = 20 * (--val)
                this.filter = JSON.stringify(filter)
                getFeedBack(sessionStorage.userId, this.filter).then(res => {
                    this.fetchList = res.data
                    this.loading = false
                })
            },
            handleView(index, row) {
                //查看
                this.dialogFormVisible = true
                this.form = row
            },
    
            handleCheck(index, row) {
                //审核
                this.$confirm('标记为已反馈, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
    
                    patchFeedBack(sessionStorage.userId, row.id, {
                        status: 1
                    }).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '标记成功',
                                type: 'success'
                            });
                            this.fetchList.forEach((item, index) => {
                                if (item.id === row.id) {
                                    this.fetchList[index].status = 1
                                }
                            })
                        }
                    }, err => {
                        this.$message.error('标记失败')
                    })
    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消标记'
                    });
                });
            },
    
            handleDelete(index, row) {
                this.$confirm('此操作将永久删除该反馈, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
    
                    deleteFeedBack(sessionStorage.userId, row.id).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功删除',
                                type: 'success'
                            });
                            this.fetchList.splice(index, 1)
                        }
                    }, err => {
                        this.$message.error('删除失败')
                    })
    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            resetForm(formName) {
                this.formInline = {
                    phone: '',
                }
                this.$refs[formName].resetFields();
            },
            handleAdd() {
                //添加商品
                this.dialogNewVisible = true
            },
            Search() {
                //搜索
                if (this.formInline.phone) {
                    getFeedBack(sessionStorage.userId, JSON.stringify({
                        "order": "id desc",
                        "limit": 20,
                        "skip": 0,
                        'include': 'userManage',
                        'where': {
                            'phone': {
                                 'like': '%25' + this.formInline.phone + '%25'
                            },
                        }
                    })).then(res => {
                        this.fetchList = res.data
                    }, err => {
                        console.log(err)
                    })
                    getFeedCount(sessionStorage.userId, JSON.stringify({

                             'phone': {
                                 'like': '%25' + this.formInline.phone + '%25'
                            },
                        
                    })).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                } else {
                    this.filter = JSON.stringify({
                        'include': 'userManage',
                        "order": "id desc",
                        "limit": 20,
                        "skip": 0,
                    })
                    //获取所有评论列表
                    getFeedBack(sessionStorage.userId, this.filter).then(res => {
                        this.fetchList = res.data
                        this.loading = false
                        console.log(this.fetchList)
    
                    })
    
                    getFeedCount(sessionStorage.userId, JSON.stringify({})).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                }
    
            },
    
    
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// FeedBack.vue?78127ef9